import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import vuetify from '@/plugins/vuetify'
import pinia from '@/stores'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ErrorHandlerService from './services/ErrorHandlerService'
import * as Sentry from "@sentry/vue";
import { SENTRY_DSN_KEY, SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE, SENTRY_REPLAYS_SESSION_SAMPLE_RATE, SENTRY_TRACES_SAMPLE_RATE } from './utils/constants'
import { getWebDomain } from './utils/helpers/app-helpers'

const app = createApp(App)

Sentry.init({
  app,
  dsn: SENTRY_DSN_KEY,
  integrations: [
    Sentry.browserTracingIntegration({ router: router.getRouterInstance() }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
  tracePropagationTargets: [
    getWebDomain(),
  ],
  replaysSessionSampleRate: SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
  replaysOnErrorSampleRate: SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
});

app.config.globalProperties.$navigator = router
app.config.errorHandler = ErrorHandlerService.setupComponentErrorHandler
app.use(pinia)
app.use(router.getRouterInstance())
app.use(vuetify)
app.component('font-awesome-icon', FontAwesomeIcon)
app.mount('#app')
